import { formatLabel } from "../../utils/format";

export const LABELS = {
  MERCHANT_INFO_TITLE: "加盟店情報",
  UPDATING_INFO_TEXT: "{0}情報更新中です",
  APPLYING_DATE: "　適用反映日　",
  IPID_TITLE: "IPID　{0}件",
  MERCHANT_NAME_TITLE: "加盟店名　{0}件",
  COMPANY_INFO_TITLE: "事業者情報",
  COMPANY_NAME: "事業者名",
  CORPORATE_NUMBER: "法人番号",
  COMPANY_NAME_KANA: "事業者名カナ",
  COMPANY_NAME_ALPHABETICAL: "事業者名英字",
  ADDRESS: "本社住所",
  PHONE_NUMBER: "電話番号",
  REFERENCE_GROUP_TITLE: "参照グループ",
  REFERENCE_GROUPS_ID: "参照グループID",
  HD_REFERENCE_GROUPS_ID: "企業ID",
  REFERENCE_GROUPS_NAME: "参照グループ名",
  NOTIFICATION_EMAIL: "精算額通知先\r\nメールアドレス",
  BANK_ACCOUNT_TITLE: "口座情報",
  BANK_CODE: "金融機関コード",
  BANK_NAME: "金融機関名",
  BANK: "金融機関",
  BRANCH_CODE: "支店コード",
  BRANCH_NAME: "支店名",
  BRANCH: "支店",
  BANK_ACCOUNT_TYPE: "口座種別",
  BANK_ACCOUNT_NUMBER: "口座番号",
  BANK_ACCOUNT_HOLDER_KANA: "口座名義カナ",
  PAYMENT_CYCLE: "支払サイクル",
  PAYMENT_TARGET_COMPANY_INFO_LABEL: "入金先事業者情報",
  ADDRESS_OTHERS: "本社住所（その他）",
  ADDRESS_KANA: "本社住所カナ",
  POSTAL_CODE: "郵便番号",
  SAME_INFO: "同上",
  UPDATE_BANK_ACCOUNT: "口座情報変更",
  UPDATING_CONTENT_TITLE: "更新中内容",
} as const;

export const UPDATING_INFO = {
  COMPANY_INFO: "事業者",
  BANK_ACCOUNT: "口座",
  NONE: "",
} as const;
export type updatingInfoType =
  (typeof UPDATING_INFO)[keyof typeof UPDATING_INFO];

export const FIELDS_LENGTH = {
  NOTIFICATION_EMAIL: 100,
  BANK_ACCOUNT_NUMBER: 10,
  BANK_ACCOUNT_HOLDER_KANA: 30,
  CORPORATE_NUMBER: 13,
  COMPANY_NAME: 30,
  COMPANY_NAME_KANA: 45,
  POSTAL_CODE: 7,
  ADDRESS_OTHERS: 100,
  ADDRESS_KANA: 100,
  PHONE_NUMBER: 13,
};

export const CONSTRAINT_TEXT = {
  NOTIFICATION_EMAIL: formatLabel("{0}文字以内", [
    FIELDS_LENGTH.NOTIFICATION_EMAIL,
  ]),
  BANK_ACCOUNT_NUMBER: formatLabel("半角数字{0}桁以内", [
    FIELDS_LENGTH.BANK_ACCOUNT_NUMBER,
  ]),
  BANK_ACCOUNT_HOLDER_KANA: formatLabel("{0}文字以内", [
    FIELDS_LENGTH.BANK_ACCOUNT_HOLDER_KANA,
  ]),
  CORPORATE_NUMBER: formatLabel("半角数字{0}桁", [
    FIELDS_LENGTH.CORPORATE_NUMBER,
  ]),
  COMPANY_NAME: formatLabel("{0}文字以内", [FIELDS_LENGTH.COMPANY_NAME]),
  COMPANY_NAME_KANA: formatLabel("全角カナ{0}文字以内", [
    FIELDS_LENGTH.COMPANY_NAME_KANA,
  ]),
  POSTAL_CODE: formatLabel("半角数字{0}桁", [FIELDS_LENGTH.POSTAL_CODE]),
  ADDRESS_OTHERS: formatLabel("{0}文字以内", [FIELDS_LENGTH.ADDRESS_OTHERS]),
  ADDRESS_KANA: formatLabel("{0}文字以内", [FIELDS_LENGTH.ADDRESS_KANA]),
  PHONE_NUMBER: formatLabel("半角数字{0}桁以内", [FIELDS_LENGTH.PHONE_NUMBER]),
};

export interface IErrMsg {
  notificationEmail?: string;
  fnnInsMthStrCd?: string;
  fnnInsBrnCd?: string;
  bankAccountNumber?: string;
  bankAccountHolderKana?: string;
  corporateNumber?: string;
  companyName?: string;
  companyNameKana?: string;
  postalCode?: string;
  paymentTargetCompanyAddress1?: string;
  paymentTargetCompanyAddress2?: string;
  paymentTargetCompanyAddress1Kana?: string;
  phoneNumber?: string;
}
